import PropTypes from 'prop-types';

import './SimpleCheckbox.css';

import { buildClass } from '../../libs/classes';

export const CheckboxTypes = {
	TICK: 'tick',
	BOX: 'box',
};

/**
 * This simple checkbox component renders a checkbox with different styles.
 * @component
 */
export const SimpleCheckbox = ({ state, label, title, type, className, onClick }) => {
	return (
		<div
			className={buildClass('simple-checkbox', className, type).add(state, 'yes', 'no')}
			title={title}
			onClick={onClick}
		>
			<div className="checkbox-body">
				<div className="checkmark" />
			</div>
			<div className="checkbox-label">{label}</div>
		</div>
	);
};

SimpleCheckbox.propTypes = {
	// Check state
	state: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
	// Label text
	label: PropTypes.string,
	// Title html attribute for component
	title: PropTypes.string,
	// Checkbox type
	type: PropTypes.oneOf(Object.values(CheckboxTypes)).isRequired,
	// Additional class
	className: PropTypes.string,
	// Callback function on click
	onClick: PropTypes.func.isRequired,
};

export default SimpleCheckbox;
